import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import 'dayjs/locale/ja';

dayjs.locale('ja');
dayjs.extend(utc);
dayjs.extend(timezone);

export const formatDate = (
  date: string | Date | number,
  format: string
): string => {
  return dayjs.utc(date).tz('Asia/Tokyo').format(format);
};

export const getToday = (): string => {
  return dayjs().tz('Asia/Tokyo').format('YYYY-MM-DD');
};
